import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient'; // adjust if needed
import { Link } from 'react-router-dom';

const Courses = () => {
  const [courses, setCourses] = useState([]);

  useEffect(() => {
    async function fetchCourses() {
      const { data, error } = await supabase
        .from('courses')
        .select('*')
        .eq('status', 'active');

      if (error) {
        console.error('❌ Error fetching courses:', error);
      } else {
        setCourses(data);
      }
    }

    fetchCourses();
  }, []);

  return (
    <main className="min-h-screen bg-gradient-to-tr from-indigo-50 to-blue-100 p-6">
      <section className="max-w-6xl mx-auto py-12 text-center">
        <h1 className="text-4xl font-extrabold text-indigo-800 mb-6">
          Explore Our Digital Literacy Courses
        </h1>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-10">
          Each course is crafted to help you build confidence and capability in today's digital world. Learn at your own pace and start mastering the skills that open doors.
        </p>

        <div className="grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {courses.map((course) => (
            <div key={course.id} className="bg-white p-6 rounded-xl shadow hover:shadow-lg transition text-left">
              <h2 className="text-xl font-semibold text-indigo-700 mb-2">{course.title}</h2>
              <p className="text-gray-700 mb-4">{course.description}</p>
              <Link
                to={`/course/${course.slug}`}
                className="inline-block mt-auto text-indigo-600 hover:text-indigo-800 font-medium"
              >
                View Course ➜
              </Link>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default Courses;
